import React,{ useEffect, useState } from 'react';
import {LoadMore,SearchBar,Page,Input } from 'react-weui';
import { getCourseList, getHotSearch, getColumnList } from '@/services/home';
import { Toast } from 'antd-mobile';

import styles from './styles.scss';
import resultStyles from '../courseList/styles.scss';
import Empty from '@/components/empty';
import SearchInput from '@/components/SearchInput';
import { getHistory,setHistory } from '@/utils/searchHistory';
import { history } from 'umi';



export default (props) => {

  const [dataList, setDataList] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [hotSearchList,setHotSearchList] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [clickLabel, setClickLabel] = useState(null);


  const[pageNo,setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数


  const [historyList, setHistoryList] = useState([]);


  useEffect(()=>{
    setHistoryList(getHistory);

    getHotSearch().then(res => {
      if (res.code == 200) {
        setHotSearchList(res.data);
      }

    });
  },[]);


  useEffect(()=>{
   if (!isSearching){
     setDataList([]);
   }
  },[isSearching]);

  useEffect(()=>{
   search(1);
  },[clickLabel]);


  function search(page,resolve, finish) {
    let params = {pageNo:page, pageSize:20};
    if (searchKey) {
      params.name = searchKey;
    }else {
      return;
    }
    setIsSearching(true);

    addHistoryItem(searchKey);

    if (!resolve) {
      Toast.loading('搜索中...',60);
    }

    getCourseList(params).then(res => {
      console.log(res);
      Toast.hide();
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断

      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e => {
      Toast.hide();
      Toast.fail('搜索失败，请重试',1);
      resolve && resolve();
    });
  }


  function addHistoryItem(text) {
    let index = historyList.indexOf(text);
    if (index !== -1) {
      historyList.splice(index,1);
    }
    historyList.unshift(text);
    if (historyList.length > 10) {
      historyList.pop();
    }

    setHistoryList(historyList);
    setHistory(historyList);
  }


  return(
    <Page transition={true} infiniteLoader={isSearching} ptr={false}
          onLoadMore={ (resolve, finish) => {
            if (dataList.length >= totalCount && totalCount !== 0) {
              finish();
              return;
            }
            search(pageNo+1, resolve,finish);
          }}>

      <SearchInput placeholder={'请输入您想要查询的课程名称或内容'}
                   value={searchKey}
                   showButton={true}
                   onChange={(text)=> {
                      setSearchKey(text);
                      if (!text) {
                        setIsSearching(false);
                      }
                   }}
                   onSearch={(text) => {
                     search(1);
                   }}
                   onConfirmKey={()=>{
                     search(1);
                   }}
      />

      {isSearching ?
        <>
          <SearchResult dataList={dataList}/>
          {dataList.length >= totalCount && totalCount !== 0 && (
            <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
              没有更多数据了
            </div>
          )}
        </>
      :
        <SearchKeys hotSearchList={hotSearchList} historyList={historyList}
                    onSelect={(key) => {
                       setSearchKey(key);
                       setClickLabel(key);
                    }}
        />
      }


    </Page>
  )
}



const SearchKeys  = (props) => {
  const {hotSearchList, historyList, onSelect} = props;


  return(
    <div className={styles.box}>
      <label className={styles.box_title}>最近搜索</label>

      <div className={styles.keys_box}>

        {historyList.map((item,i) =>(
          <div className={styles.key_item} key={''+i} onClick={() => {
            onSelect(item);
          }}>
            {item}
          </div>
        ))}
      </div>

      <label className={styles.box_title}>热门搜索</label>

      <div className={styles.keys_box}>
        {hotSearchList.map(item => (
          <div className={styles.key_item} key={item.id} onClick={() => {
            onSelect(item.name);
          }}>
            {item.name}
          </div>
        ))}
      </div>
    </div>
  )
};


const SearchResult  = (props) => {
  const {dataList} = props;
  return(
    <div className={styles.box}>
      <label className={styles.box_title}>搜索结果</label>

      {dataList.length ? dataList.map(item => (

          <div className={resultStyles.item_box} key={item.id} onClick={()=>{
            history.push('/home/courseDetail?courseId=' + item.id + '&title=' + item.name);
          }}>

            <div className={resultStyles.imgBox}>
              <img className={resultStyles.item_img} src={item.image}/>

              {item.type !== '3' && <img className={resultStyles.item_play}
                                         src={item.type == '1' ? require('@/assets/ic_play.png') : require('@/assets/music_play.png')}/>}
            </div>

            <div className={resultStyles.item_content}>
              <label className={resultStyles.item_title}>{item.name}</label>
              <label className={resultStyles.item_subtitle}>{item.intro}</label>

            </div>
          </div>

        ))
        :
        <Empty text={'暂无数据'}/>
      }

    </div>
  )
}


